import { render, staticRenderFns } from "./TelcoFormGeneral.vue?vue&type=template&id=152cb288&"
import script from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('152cb288', component.options)
    } else {
      api.reload('152cb288', component.options)
    }
    module.hot.accept("./TelcoFormGeneral.vue?vue&type=template&id=152cb288&", function () {
      api.rerender('152cb288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTelco/MantenedorTelcoCrear/TelcoFormGeneral.vue"
export default component.exports